import { Api } from '../api';
import { profile } from '../endpoints';
import type {
  GetAccountsResponse,
  GetUserProfileResponse,
  SendCodeToEmailRequest,
  SendCodeResponse,
  SendCodeToMobileRequest,
  UpdateProfileRequest,
} from './models';

export class ProfileApi extends Api {
  static getAccounts = () => this.get<GetAccountsResponse[]>({ url: profile.getAccounts() });

  static getUserProfile = (accountId: string) => this.get<GetUserProfileResponse>({ url: profile.getUserProfile(accountId) });

  static sendCodeToEmail = (request: SendCodeToEmailRequest) =>
    this.post<SendCodeToEmailRequest, SendCodeResponse>({ url: profile.sendCodeToEmail(), queryParams: request });

  static sendCodeToMobile = (request: SendCodeToMobileRequest) =>
    this.post<SendCodeToMobileRequest, SendCodeResponse>({ url: profile.sendCodeToMobile(), queryParams: request });

  static updateProfile = (request: UpdateProfileRequest, accountId: number) =>
    this.post<UpdateProfileRequest, undefined>({ url: profile.updateProfile(accountId), data: request });
}
